export const selectKeepArchived = state => state.settingsData.isKeepArchived;
export const selectNotificationsEnabled = state => state.settingsData.isNotificationsEnabled;
export const selectSettingsData = state => state.settingsData;

